export function getExpenseAccountsDropDown(expenseAccounts) {
    console.log("expAc2 +++++++++: getExpenseAccountsDropDown")

    let dropdownArray = [];
    expenseAccounts.forEach(function (element) {
       console.log("expAc21 for each:" + JSON.stringify(element, null, 3));
        let dropdown = {};
        dropdown.category = 'expenseAccount';
        dropdown.label = element.accountname;
        dropdown.value = element.accountname;
        dropdown.key = element.accountname;
        dropdownArray.push(dropdown)
    });

   console.log("expAc21 dropdown:" + JSON.stringify(dropdownArray, null, 3));
    return dropdownArray;
}


export function getColorsDropDown(shirtColors) {
    //console.log("gcltx2 +++++++++:" + JSON.stringify(shirtColors, null, 3))

    let dropdownArray = [];
    shirtColors.forEach(function (element) {
       // console.log("gshtx33 for each:" + JSON.stringify(element, null, 3));
        let dropdown = {};
        dropdown.category = 'shirtColor';
        dropdown.label = element.color;
        dropdown.value = element.color;
        dropdown.key = element.color;
        dropdownArray.push(dropdown)
    });

   // console.log("pltx13 dropdown:" + JSON.stringify(dropdownArray, null, 3));
    return dropdownArray;
}


export function getDiscountCodesDropdown(discountCodes) {
    //console.log("gltx +++++++++:" + JSON.stringify(salesPeople, null, 3))

    let dropdownArray = [];
    discountCodes.forEach(function (element) {
       // console.log("dscx21 for each:" + element.discountcode);
        let dropdown = {};
        dropdown.category = 'discountCode';
        dropdown.label = element.description;
        dropdown.value = element.discountcode;
        dropdown.key = element.discountcode;
        dropdownArray.push(dropdown)
    });

   // console.log("dscx21:" + JSON.stringify(dropdownArray, null, 3))
    return dropdownArray;
    
}

export function getDeliveryGuysDropdown(delGuys) {
    //console.log("gltx +++++++++:" + JSON.stringify(delGuys, null, 3))

    let dropdownArray = [];
    delGuys.forEach(function (element) {
       // console.log("gltx12inside for each:" + element.iddeliverypeople);
        let dropdown = {};
        dropdown.category = 'deliveryPerson';
        dropdown.label = element.name;
        dropdown.value = element.name;
        dropdown.key = element.name;
        dropdown.phone = element.phone;
        dropdownArray.push(dropdown)
    });

    //console.log("getdelguy dropdown:" + JSON.stringify(dropdownArray, null, 3));
    return dropdownArray;

    // {
    //     "grouping": "deliveryGuys",
    //     "category": "deliveryPerson",
    //     "label": "mark",
    //     "value": "mark",
    //     "key": "mark",
    //     "phone": "0751909641",
    //     "objectID": "59200722"
    //   }
    
}

export function getSalesPeopleDropDown(salesPeople) {
    //console.log("gltx +++++++++:" + JSON.stringify(salesPeople, null, 3))

    let dropdownArray = [];
    salesPeople.forEach(function (element) {
       // console.log("gltx12inside for each:" + element.idadmins);
        let dropdown = {};
        dropdown.category = 'salesPersonId';
        dropdown.label = element.name;
        dropdown.value = element.idadmins;
        dropdown.key = element.idadmins;
        dropdown.phone = element.phone;
        dropdownArray.push(dropdown)
    });

    //console.log("getSales4 dropdown:" + JSON.stringify(dropdownArray, null, 3));
    return dropdownArray;

    // {
    //     "category": "replacementReason",
    //     "label": "Shirt Wrong color",
    //     "value": "wrong_color",
    //     "key": "wrong_color"
    //   },
    
}

export function getCustomerDropDown(customers) {
    //console.log("cltx +++++++++:" + JSON.stringify(customers, null, 3))

    let dropdownArray = [];
    customers.forEach(function (element) {
      //  console.log("cltx12inside for each:" + element.idadmins);
        let dropdown = {};
        dropdown.category = 'customerId';
        dropdown.label = element.customername;
        dropdown.value = element.idlargeprojectcustomer;
        dropdown.key = element.idlargeprojectcustomer;
        dropdownArray.push(dropdown)
    });

    console.log("cltx13 dropdown:" + JSON.stringify(dropdownArray, null, 3));
    return dropdownArray;

    // {
    //     "category": "replacementReason",
    //     "label": "Shirt Wrong color",
    //     "value": "wrong_color",
    //     "key": "wrong_color"
    //   },
}

export function getProjectDropDown(projects) {
    //console.log("pltx +++++++++:" + JSON.stringify(projects, null, 3))

    let dropdownArray = [];
    projects.forEach(function (element) {
       // console.log("pltx12inside for each:" + element.idlargeprojects);
        let dropdown = {};
        dropdown.category = 'projectId';
        dropdown.label = element.name;
        dropdown.value = element.idlargeprojects;
        dropdown.key = element.idlargeprojects;
        dropdownArray.push(dropdown)
    });

    console.log("pltx13 dropdown:" + JSON.stringify(dropdownArray, null, 3));
    return dropdownArray;
}

export function getShirtTypeDownDownNew(shirtTypes) {
   // console.log("gshtx31 +++++++++:" + JSON.stringify(shirtTypes, null, 3))

    let dropdownArray = [];
    shirtTypes.forEach(function (element) {
       // console.log("gshtx33 for each:" + JSON.stringify(element, null, 3));
        let dropdown = {};
        dropdown.category = 'shirtTypeId';
        dropdown.label = element.shirttype;
        dropdown.value = element.idshirtypes;
        dropdown.key = element.idshirtypes;
        dropdown.stockitem = element.stockitem;
        dropdown.shirttypebuycost = element.shirttypebuycost;
        dropdownArray.push(dropdown)
    });

   // console.log("pltx13 dropdown:" + JSON.stringify(dropdownArray, null, 3));
    return dropdownArray;
}

export function getShirtTypeDownDown(shirtTypes) {
    //console.log("pltx +++++++++:" + JSON.stringify(shirtTypes, null, 3))

    let dropdownArray = [];
    shirtTypes.forEach(function (element) {
       // console.log("pltx12inside for each:" + element.idshirtypes);
        let dropdown = {};
        dropdown.category = 'shirtTypeId';
        dropdown.label = element.shirttype;
        dropdown.value = element.idshirtypes;
        dropdown.key = element.idshirtypes;
        dropdownArray.push(dropdown)
    });

   // console.log("pltx13 dropdown:" + JSON.stringify(dropdownArray, null, 3));
    return dropdownArray;
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/LargeProjectUtils.js